import styled from 'styled-components'

const CarouselSlot = styled.div`
  flex: 1 0 100%;
  flex-basis: 80%;
  order: ${props => props.order};

  transition: opacity 0.5s ease;
`

export default CarouselSlot



// WEBPACK FOOTER //
// ./src/components/shared/Carousel/CarouselSlot.js